import React from 'react';
import MainHeader from './MainHeader';

export default function Contact() {
  return <>
    <MainHeader />
  </>;
}
